module.exports = __webpack_public_path__ + "img/card_notonline.5bef4e47.png";